import { ITimeRangeResponse } from '@kcftech/prometheus-client';
import { sdClient } from 'contexts/SDKClientContext';
import {
    BaseDataSourceOptions,
    DataSourceQuery,
} from 'custom_hooks/data_hooks/data_source/data_source';
import {
    PagedDataSource,
    usePagedDataSource,
} from 'custom_hooks/data_hooks/data_source/usePagedDataSource';
import { buildOrderBy, toDataSourceResult, useQueryAll } from 'utils/query_v3';

export type CorporationTimeRangeFilter = Readonly<{
    corporationId: string;
    nameSearch: string | undefined;
}>;

export type UseCorporationTimeRangeDataSourceOptions = BaseDataSourceOptions<
    ITimeRangeResponse,
    CorporationTimeRangeFilter
>;

export type CorporationTimeRangeDataSource = PagedDataSource<
    ITimeRangeResponse,
    CorporationTimeRangeFilter
>;

const queryFn: DataSourceQuery<ITimeRangeResponse, CorporationTimeRangeFilter> = ({
    filter: { corporationId, nameSearch },
    sort,
    page,
    pageLimit,
}) => {
    const orderBy = buildOrderBy(sort);
    return toDataSourceResult(
        sdClient.getCorporationTimeRanges({
            corporationId,
            page,
            pageLimit,
            orderBy,
            nameSearch,
        }),
    );
};

export function useCorporationTimeRangeDataSource(
    options: UseCorporationTimeRangeDataSourceOptions,
): CorporationTimeRangeDataSource {
    return usePagedDataSource({ ...options, query: queryFn });
}

const defaultSortExpr = buildOrderBy(['TimeInSeconds']);

export const useAllCorporationTimeRanges = (corporationId: string) =>
    useQueryAll(['corporation-time-ranges', corporationId], (page) =>
        sdClient.getCorporationTimeRanges({
            corporationId,
            page,
            pageLimit: 100,
            orderBy: defaultSortExpr,
        }),
    );
